import { GlobalMenuWrapper } from 'modules/globalMenu/components/GlobalMenuWrapper';
import { Header } from 'modules/layout/const';

import { HeaderContent } from '../Header/components/HeaderContent';
import { MobileMenu } from '../MobileMenu';
import { useMobileHeaderStyles } from './useMobileHeaderStyles';
import { useTopBannersHeight } from '../TopBannersHeightProvider';

interface MobileHeaderProps {
  className?: string;
}

export const MobileHeader = ({ className }: MobileHeaderProps) => {
  const { topBannersHeight } = useTopBannersHeight();

  const { classes, cx } = useMobileHeaderStyles(topBannersHeight);

  return (
    <header className={cx(classes.root, className)}>
      <GlobalMenuWrapper />
      <div className={classes.buttons}>
        <HeaderContent type={Header.Mobile} />
        <MobileMenu hasMenu={false} />
      </div>
    </header>
  );
};
